import { gql } from '@apollo/client';

export const QUERY_TERMS_AND_CONDITIONS = gql`
  query QueryTermsAndConditions {
    termAndCondition {
      data {
        attributes {
          title
          content
        }
      }
    }
  }
`;
